import React from 'react'
import {
  DesignedModal,
  Button,
  StyledText,
  OutsideLink,
} from '@clickcease/cc-client-components-lib'
import { useTranslation, Trans } from 'react-i18next'
import { useIsProductTrial } from 'Hooks/trial/useIsProductTrial'
import { getProductName } from 'Utils/productName'
import { ProductTypesWithoutBundle } from 'Types/ProductTypes'
import { useZendeskChat } from 'Hooks/zendesk/useZendeskChat'

export const ConfirmationProductCancelModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean
  setIsOpen: (val: boolean) => void
}) => {
  const { t } = useTranslation('accountSettings')
  const { allowedProduct } = useIsProductTrial()
  const { openChat } = useZendeskChat()

  return (
    <DesignedModal
      isOpen={isOpen}
      title={t('plan_details.confirm_modal.title')}
      onOpenChange={setIsOpen}
      style={{ width: '456px' }}
      actions={
        <>
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            {t('plan_details.confirm_modal.close_button')}
          </Button>
        </>
      }
    >
      <StyledText style={{ display: 'block' }}>
        <Trans
          t={t}
          i18nKey={'plan_details.confirm_modal.description_product'}
          values={{ product: getProductName(allowedProduct as ProductTypesWithoutBundle) }}
          components={{ br: <br />, support: <OutsideLink onClick={openChat} /> }}
        />
      </StyledText>
    </DesignedModal>
  )
}
